// src/hooks/useSubscription.js
import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export function useSubscription() {
  const { profile, profileLoading } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Attendre que le profil soit chargé
    if (!profileLoading) {
      setLoading(false);
    }
  }, [profile, profileLoading]);

  // Retourner un objet subscription même si profile est null
  return {
    subscription: profile ? {
      status: profile.subscription_status || profile.stripe_subscription_status || 'active',
      plan: profile.plan || 'standard',
      trial_end: profile.trial_end || null,
      is_frozen: profile.is_frozen || false,
    } : {
      status: 'active', // Défaut pour éviter les blocages
      plan: 'standard',
      trial_end: null,
      is_frozen: false,
    },
    loading: loading || profileLoading,
    profile, // Exposer le profil complet si besoin
  };
}